export default "__VITE_ASSET__CLctXSKo__"